"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const BaseText_1 = __importDefault(require("./BaseText"));
function H3({ children, variant = 'headline-small', className = '', ...rest }) {
    return ((0, jsx_runtime_1.jsx)(BaseText_1.default, { tag: "h3", type: variant, className: className, ...rest, children: children }));
}
exports.default = H3;
